<template>
    <div v-if="asyncDataStatus_ready">

    <v-row>
      <v-breadcrumbs :items="breadcrumbs" style="padding: 12px">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :href="item.href"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-row>

    <v-row justify="space-between">
      <v-col cols="6">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-if="this.clients.length"
              placeholder="Išči (ime ali davčna)..."
              append-icon="mdi-search"
              v-model="filter"
              @keydown.esc="filter=''"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-checkbox
              color="#0F998E"
              v-model="activeOnly"
              label="Samo aktivni"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'ClientsNew', params: { companyType: 1, companyTypeName: 'Clients' }})"
        >
          Nova stranka
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col style="color: #0F998E">
        Razvrsti: <ButtonActionSortAZ class="ml-2" @click="sort('AZ')" /><ButtonActionSortZA class="mr-2" @click="sort('ZA')" />
      </v-col>
    </v-row>

    <v-row v-if="this.clients.length">
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Naziv
                </th>
                <th class="text-left" v-if="!isMobile && !isSmallTablet">
                  Naslov
                </th>
                <th class="text-left">
                  Davčna št.
                </th>
                <th class="text-left" v-if="!isMobile && !isSmallTablet">
                  Kontakt
                </th>
                <th class="text-left" v-if="!isMobile">
                  Aktiven
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="isMobile">
              <tr
                v-for="client in filteredClients"
                :key="client.id"
              >
                <td>{{ client.name }}</td>
                <td>{{ client.tax_number }}</td>
                <td>
                  <ClientCardButtonActions
                    :client="client"
                    @identity="takeIdentity(client)"
                    @edit="$router.push({name: 'ClientsEdit', params: { id: client.id, companyTypeName: 'Clients' }})"
                    @details="$router.push({name: 'ClientsDetails', params: { id: client.id, companyTypeName: 'Clients' }})"
                    @businessUnits="$router.push({name: 'ClientsBusinessUnits', params: { childCompanyId: client.id }})"
                    @certificates="$router.push({name: 'ClientsCertificates', params: { childCompanyId: client.id }})"
                  />
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="isSmallTablet">
              <tr
                v-for="client in filteredClients"
                :key="client.id"
              >
                <td>{{ client.name }}</td>
                <td>{{ client.tax_number }}</td>
                <td><ActiveIcon :value="client.is_active" /></td>
                <td>
                  <ClientCardButtonActions
                    :client="client"
                    @identity="takeIdentity(client)"
                    @edit="$router.push({name: 'ClientsEdit', params: { id: client.id, companyTypeName: 'Clients' }})"
                    @details="$router.push({name: 'ClientsDetails', params: { id: client.id, companyTypeName: 'Clients' }})"
                    @businessUnits="$router.push({name: 'ClientsBusinessUnits', params: { childCompanyId: client.id }})"
                    @certificates="$router.push({name: 'ClientsCertificates', params: { childCompanyId: client.id }})"
                  />
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="isTablet || isNotFullHD">
              <tr
                v-for="client in filteredClients"
                :key="client.id"
              >
                <td>{{ client.name }}</td>
                <td>{{ fullAddress(client) }}</td>
                <td>{{ client.tax_number }}</td>
                <td>{{ client.contact }}</td>
                <td><ActiveIcon :value="client.is_active" /></td>
                <td>
                  <ClientCardButtonActions
                    :client="client"
                    @identity="takeIdentity(client)"
                    @edit="$router.push({name: 'ClientsEdit', params: { id: client.id, companyTypeName: 'Clients' }})"
                    @details="$router.push({name: 'ClientsDetails', params: { id: client.id, companyTypeName: 'Clients' }})"
                    @businessUnits="$router.push({name: 'ClientsBusinessUnits', params: { childCompanyId: client.id }})"
                    @certificates="$router.push({name: 'ClientsCertificates', params: { childCompanyId: client.id }})"
                  />
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr
                v-for="client in filteredClients"
                :key="client.id"
              >
                <td>{{ client.name }}</td>
                <td>{{ fullAddress(client) }}</td>
                <td>{{ client.tax_number }}</td>
                <td>{{ client.contact }}</td>
                <td><ActiveIcon :value="client.is_active" /></td>
                <td>
                  <ButtonActionIdentity @click="takeIdentity(client)" />
                  <ButtonActionEdit @click="$router.push({name: 'ClientsEdit', params: { id: client.id, companyTypeName: 'Clients' }})" />
                  <ButtonActionDetails @click="$router.push({name: 'ClientsDetails', params: { id: client.id, companyTypeName: 'Clients' }})" />
                  <ButtonActionBusinessUnit @click="$router.push({name: 'ClientsBusinessUnits', params: { childCompanyId: client.id }})" />
                  <ButtonActionCertificate @click="$router.push({name: 'ClientsCertificates', params: { childCompanyId: client.id }})" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje nove stranke uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { siIncludes } from '@/utils/str'
import { debounce } from '@/utils/helpers'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ActiveIcon from '@/components/ActiveIcon'
import ButtonActionIdentity from '@/components/ButtonActionIdentity'
import ButtonActionDetails from '@/components/ButtonActionDetails'
import ButtonActionCertificate from '@/components/ButtonActionCertificate'
import ButtonActionBusinessUnit from '@/components/ButtonActionBusinessUnit'
import ButtonActionSortAZ from '@/components/ButtonActionSortAZ'
import ButtonActionSortZA from '@/components/ButtonActionSortZA'
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ClientCardButtonActions from '@/components/ClientCardButtonActions'

export default {
  mixins: [
    asyncDataStatus
  ],
  components: {
    ActiveIcon,
    ButtonActionSortAZ,
    ButtonActionSortZA,
    ButtonActionIdentity,
    ButtonActionDetails,
    ButtonActionCertificate,
    ButtonActionBusinessUnit,
    ButtonActionEdit,
    ClientCardButtonActions
  },
  data () {
    return {
      filter: '',
      timeoutLifted: true,
      clientsFiltered: null,
      sortMethod: null,
      activeOnly: true,
      breadcrumbs: [
        {
          text: 'Stranke',
          disabled: false,
          href: '/clients'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('companies', ['clients']),
    customers () {
      let clients = this.clients
      if (this.sortMethod) {
        return clients.sort((a, b) => {
          if (this.sortMethod === 'AZ') {
            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
          }
          if (this.sortMethod === 'ZA') {
            return a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1
          }
        })
      }
      return clients.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1
        } else if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1
        } else {
          return 0
        }
      })
    },
    filteredClients () {
      if (this.timeoutLifted) {
        return this.customers.filter(client => (!this.activeOnly || client.is_active) && [client.name, client.tax_number].some(this.matchFilter))
      } else {
        return []
      }
    },
    isMobile () {
      return this.$vuetify.breakpoint.xsOnly
    },
    isSmallTablet () {
      return this.$vuetify.breakpoint.smOnly
    },
    isTablet () {
      return this.$vuetify.breakpoint.mdOnly
    },
    isNotFullHD () {
      return this.$vuetify.breakpoint.lgOnly
    }
  },
  methods: {
    ...mapActions('companies', ['loadMyCompany', 'loadChildCompanies', 'takeCompanyIdentity']),
    ...mapActions('clients', ['setFilter']),
    deleteItem (item) {
      this.deleteClient({ id: item.id })
    },
    matchFilter (testString) {
      return siIncludes({ haystack: testString, needle: this.filter })
    },
    sort (method) {
      this.sortMethod = method
    },
    fullAddress (client) {
      let address = client.address
      if (client.city) {
        if (client.post_code) {
          address += `, ${client.post_code} ${client.city}`
        } else {
          address += `, ${client.city}`
        }
      }
      return address
    },
    takeIdentity (item) {
      this.takeCompanyIdentity(item.id)
    },
    setFilterDebounced: debounce(function(filter) {
      this.setFilter(filter)
      this.timeoutLifted = true
    }, 300)
  },
  created () {
    this.loadChildCompanies()
      .then(companies => {
        this.filter = this.$store.state.clients.filter
        this.asyncDataStatus_fetched()
      })
  },
  watch: {
    filter: {
      handler (filter) {
        this.timeoutLifted = false
        this.setFilterDebounced(filter)
      },
      immediate: true,
    }
  }
}
</script>
